import { render, staticRenderFns } from "./CockpitActiveOrderHistoryTab.vue?vue&type=template&id=46b0c4a2&scoped=true"
import script from "./CockpitActiveOrderHistoryTab.vue?vue&type=script&lang=js"
export * from "./CockpitActiveOrderHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./CockpitActiveOrderHistoryTab.vue?vue&type=style&index=0&id=46b0c4a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b0c4a2",
  null
  
)

export default component.exports